var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfoIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.5C0 3.175 2.675 0.5 6 0.5C9.325 0.5 12 3.175 12 6.5C12 9.825 9.325 12.5 6 12.5C2.675 12.5 0 9.825 0 6.5ZM6.75019 4.27508C6.75019 3.85008 6.42519 3.52508 6.00019 3.52508C5.57519 3.52508 5.25019 3.85008 5.25019 4.27508C5.25019 4.70008 5.57519 5.02508 6.00019 5.02508C6.42519 5.02508 6.75019 4.70008 6.75019 4.27508ZM7.00045 9.00008C7.15045 9.00008 7.25045 8.90008 7.25045 8.77508V8.27508C7.25045 8.12508 7.12545 8.00008 7.00045 8.00008C6.85045 8.00008 6.75045 7.90008 6.75045 7.77508V5.77508C6.75045 5.62508 6.62545 5.50008 6.50045 5.50008H5.00045C4.85045 5.50008 4.75045 5.65008 4.75045 5.77508V6.27508C4.75045 6.42508 4.87545 6.50008 5.00045 6.50008C5.15045 6.50008 5.25045 6.65008 5.25045 6.77508V7.77508C5.25045 7.92508 5.12545 8.00008 5.00045 8.00008C4.85045 8.00008 4.75045 8.15008 4.75045 8.27508V8.77508C4.75045 8.92508 4.87545 9.00008 5.00045 9.00008H7.00045Z",
    fill: "#999999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/info-icon.bde52039bcae4e828b28768e292882b3.svg";